import React from "react";
import { CiCircleCheck } from "react-icons/ci";
import { cn } from "../../../utils/twMerge";
import { useTranslation } from "react-i18next";

const ListView = ({ example, className, data }) => {
  const { t } = useTranslation("result");
  return (
    <div className={cn("px-[3rem] md-max:px-[1.5rem] flex flex-col gap-8", className)}>
      {data?.map((item, index) => (
        <div key={index} className="flex gap-5 md-max:justify-between md-max:w-full">
          <div className="w-[5%] flex justify-end">
          <CiCircleCheck className="text-[#35C759] mt-0.5 text-3xl" />
          </div>
          <div className="flex flex-col gap-2 w-[95%]">
            <p className="font-semibold text-xl">{item?.title}</p>
            <p className="text-[#4B5563] font-light">
              {item?.description}
            </p>
            {example && (
              <p className="text-[#4B5563] font-light">
                <span className="text-[#222222]">{t("example")}: </span><br />
                {item?.example}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListView;
